import React, { useEffect, useContext } from 'react';

import { EventMarketingInterface } from "../../../shared/interfaces/marketing/event-marketing.interface";
import { EVENT_MARKETING_TYPE } from 'config/enums';
import { TrackManagementProps } from 'shared/interfaces/marketing/event-marketing-props.interface';
import { FacebookPixelContext } from "../../../context/tracking/declarations";

const FacebookPixelManagement: React.FC<TrackManagementProps> = ({ data }) => {
	const { state, setState } = useContext(FacebookPixelContext);

	useEffect(() => () => {
		setState({
			active: false,
			code: '',
			eventCheckout: false,
			eventInitiateCheckout: false,
			eventAddToCart: false,
			eventLead: false,
			eventAddPaymentInfo: false,
		})
	}, [])

	useEffect(() => {
		if (!data) return;
		const pixel = data.find((el: EventMarketingInterface) => el.type === EVENT_MARKETING_TYPE.FACEBOOK_PIXEL);
		if (pixel) {
			setPixelValues(pixel);
		}
	}, [data]);

	useEffect(() => {
		if (!state.code) {
			return;
		}
		const script = document.createElement("script");
		const data = document.querySelectorAll<HTMLScriptElement>("[id^='fb-pixel-']");

		if (!data.length) {
			script.id = `fb-pixel-${state.code}`;
			script.async = true;
			script.innerHTML = `
			  !function(f,b,e,v,n,t,s)
			  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
			  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
			  if(!f._fbq)f._fbq=n; n.push=n; n.loaded=!0;n.version='2.0';
			  n.queue=[]; t=b.createElement(e);t.async=!0;
			  t.src=v; s=b.getElementsByTagName(e)[0];
			  s.parentNode.insertBefore(t,s)
			  }(window, document, 'script',
			  'https://connect.facebook.net/en_US/fbevents.js');
			  fbq('init', '${state.code}');
			  fbq('track', 'PageView');
			  fbq.disablePushState = true;
			`;
			document.head.appendChild(script);
			if (window.fbq) {
				window.fbq('set', 'autoConfig', false, state.code);
			}
		}
	}, [state.code]);

	useEffect(() => {
		return () => {
			removeFacebookPixel();
		}
	}, []);

	const setPixelValues = (pixel: EventMarketingInterface) => {
		setState({
			active: (pixel.status === 'ENABLED'),
			code: pixel.options?.code ?? '',
			eventInitiateCheckout: pixel.options?.initiateCheckout ?? false,
			eventCheckout: pixel.options?.checkout ?? false,
			eventAddToCart: pixel.options?.addToCart ?? false,
			eventLead: pixel.options?.createLead ?? false,
			eventAddPaymentInfo: pixel.options?.addPaymentInfo ?? false,
		})
	}

	const removeFacebookPixel = () => {
		document.querySelectorAll<HTMLScriptElement>("[id^='fb-pixel-']")
			.forEach(el => el.remove());
		if (window.fbq) {
			delete window.fbq;
		}
		if (window._fbq) {
			delete window._fbq;
		}
		setState({
			active: false,
			code: '',
			eventCheckout: false,
			eventInitiateCheckout: false,
			eventAddToCart: false,
			eventLead: false,
			eventAddPaymentInfo: false,
		})
	}

	return (<></>);
}

export default FacebookPixelManagement;
